/* eslint-disable max-len */
import { IValidateUserSignin } from 'src/interfaces';
import http from './http';

class MFAService {
  static generateNewQRCode(data: IValidateUserSignin): Promise<{ mfa_activated: boolean; qr_code: string }> {
    return http.put('/auth/mfa', data).then(resp => resp.data);
  }

  static validateUserAndPass(
    data: IValidateUserSignin
  ): Promise<{ mfa_activated: boolean; qr_code: string; access_token?: string; permissions?: any[] }> {
    return http.post('/auth/mfa', data).then(resp => resp.data);
  }
}
export default MFAService;
